(function () {
  // ---- helpers ----
  function isTouchDevice() {
    return window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches;
  }

  function getSelectedValueEl(container) {
    return container.querySelector(".swatches__option-value");
  }

  function getCheckedLabel(container) {
    const checked = container.querySelector('input.swatches__form--input:checked');
    if (!checked) return null;
    const label = container.querySelector(`label.swatches__form--label[for="${checked.id}"]`);
    return { checked, label };
  }

  function setOptionText(container, text) {
    const valueEl = getSelectedValueEl(container);
    if (valueEl) valueEl.textContent = text;
  }

  // ---- 1) Tap & hold (mobile): preview colour name in the existing top line ----
  function initTapHoldPreview() {
    if (!isTouchDevice()) return;

    document.querySelectorAll(".swatches__container.js-variant-selector").forEach((container) => {
      // only apply to colour swatches
      if (!container.classList.contains("wcw-has-colour-swatches")) return;

      let pressTimer = null;
      let startX = 0;
      let startY = 0;
      let longPressFired = false;
      let restoreText = null;

      // capture click after long press so it doesn't toggle selection
      container.addEventListener(
        "click",
        (e) => {
          if (!longPressFired) return;
          const label = e.target.closest("label.swatches__form--label");
          if (!label) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          longPressFired = false;
        },
        true
      );

      container.querySelectorAll(".swatches__swatch--color label.swatches__form--label").forEach((label) => {
        const swatchEl = label.closest(".js-swatch-element");
        const caption = swatchEl ? swatchEl.querySelector(".caption") : null;
        const labelText = caption ? caption.textContent.trim() : "";

        label.addEventListener("touchstart", (e) => {
          if (e.touches.length !== 1) return;

          longPressFired = false;
          const t = e.touches[0];
          startX = t.clientX;
          startY = t.clientY;

          // what text should we restore to?
          const checkedInfo = getCheckedLabel(container);
          restoreText = checkedInfo ? checkedInfo.checked.value : (getSelectedValueEl(container)?.textContent || "");

          // long press triggers after ~350ms
          pressTimer = window.setTimeout(() => {
            if (!labelText) return;
            longPressFired = true;
            setOptionText(container, labelText);
          }, 350);
        }, { passive: true });

        label.addEventListener("touchmove", (e) => {
          if (!pressTimer) return;
          const t = e.touches[0];
          const dx = Math.abs(t.clientX - startX);
          const dy = Math.abs(t.clientY - startY);
          if (dx > 10 || dy > 10) {
            window.clearTimeout(pressTimer);
            pressTimer = null;
          }
        }, { passive: true });

        function endPress() {
          if (pressTimer) {
            window.clearTimeout(pressTimer);
            pressTimer = null;
          }
          // if we were previewing, restore on release
          if (longPressFired && restoreText != null) {
            setOptionText(container, restoreText);
            // keep the suppression flag briefly so click doesn't select
            window.setTimeout(() => (longPressFired = false), 250);
          }
        }

        label.addEventListener("touchend", endPress, { passive: true });
        label.addEventListener("touchcancel", endPress, { passive: true });
      });
    });
  }

  // ---- 2) Click carousel image -> select matching variant -> selects swatch ----
 function initCarouselClickSelect() {
  // Find product JSON (common Shopify pattern). If not found, bail safely.
  const jsonEl =
    document.querySelector('script[type="application/json"][data-product-json]') ||
    document.querySelector('script[type="application/json"][id^="ProductJson"]') ||
    document.querySelector('script[type="application/json"][id*="ProductJson"]') ||
    document.querySelector('script[type="application/json"][data-product]');

  if (!jsonEl) return;

  let product = null;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  if (!product || !product.variants) return;

  const variants = product.variants;

  function extractMediaIdFromTarget(target) {
    const el =
      target.closest("[data-image-id]") ||
      target.closest("[data-media-id]") ||
      target.closest("[data-media]") ||
      target.closest(".js-thumb-item-img") ||
      target.closest("img");

    if (!el) return null;

    // Direct attributes
    const imgId = el.getAttribute && el.getAttribute("data-image-id");
    const mediaId = el.getAttribute && el.getAttribute("data-media-id");

    // Some themes store on parent wrappers
    const parent = el.closest && el.closest("[data-image-id],[data-media-id]");
    const parentImgId = parent && parent.getAttribute("data-image-id");
    const parentMediaId = parent && parent.getAttribute("data-media-id");

    const raw = imgId || mediaId || parentImgId || parentMediaId;
    if (!raw) return null;

    const n = Number(raw);
if (!Number.isFinite(n)) return null;

/* WCW guard: ignore generic product image clicks */
const img = target.closest && target.closest("img");
if (img) {
  const alt = (img.getAttribute("alt") || "").trim().toLowerCase();
  // generic product image alt — do NOT select a variant
  if (alt === "camarose - midnatssol") return null;
}

return n;

  }

  function matchVariantByMediaId(id) {
    return variants.find((v) => {
      const fm = v && v.featured_media && Number(v.featured_media.id);
      const fi = v && v.featured_image && Number(v.featured_image.id);
      const legacy = v && (Number(v.image_id) || Number(v.featured_image_id));
      return fm === id || fi === id || legacy === id;
    });
  }

  function selectVariantOptionsFromMatch(match) {
    if (!match || !match.options) return;

    document.querySelectorAll(".swatches__container.js-variant-selector").forEach((container) => {
      const idx = Number(container.getAttribute("data-option-index")); // 1-based
      if (!idx || !match.options[idx - 1]) return;

      const desiredValue = match.options[idx - 1];

      const input = container.querySelector(
        `input.swatches__form--input[value="${CSS.escape(desiredValue)}"]`
      );
      if (!input) return;

      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("click", { bubbles: true }));
      }
    });
  }
function setAddToCartEnabled(enabled) {
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    const btn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');
    if (!btn) return;

    btn.disabled = !enabled;
    btn.setAttribute("aria-disabled", (!enabled).toString());
    btn.classList.toggle("is-disabled", !enabled);

    // Also clear the variant id when disabling (prevents accidental add)
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && !enabled) idInput.value = "";
  });
}

function clearSwatchSelectionUI() {
  // Uncheck all swatch radios
  document.querySelectorAll(".swatches__container.js-variant-selector").forEach((container) => {
    container
      .querySelectorAll('input.swatches__form--input[type="radio"]')
      .forEach((input) => {
        input.checked = false;
      });

    // Clear the displayed chosen value (the text beside "Color:")
    const valueEl = container.querySelector(".swatches__option-value");
    if (valueEl) valueEl.textContent = "Select a colour";

  });

  // Disable Add to cart until user explicitly picks a variant again
  setAddToCartEnabled(false);
}

// If customer selects any swatch afterwards, re-enable Add to cart
document.addEventListener("change", (e) => {
  if (e.target && e.target.matches('input.swatches__form--input[type="radio"]')) {
    setAddToCartEnabled(true);
  }
});

  // Mobile-safe: listen to pointerup/touchend (click often doesn't fire on swipeable galleries)
  function handler(e) {
  // Only respond to real image clicks/taps (avoid random clicks elsewhere)
  const img = e.target && e.target.closest && e.target.closest("img");
  if (!img) return;

  const id = extractMediaIdFromTarget(e.target);
  const match = id ? matchVariantByMediaId(id) : null;

  // If image doesn't map to any variant = generic product image -> CLEAR selection
  if (!match) {
    clearSwatchSelectionUI();
    return;
  }

  // Variant image -> select matching swatch/variant
  selectVariantOptionsFromMatch(match);
}


  document.addEventListener("click", handler, true);
  document.addEventListener("pointerup", handler, true);
  document.addEventListener("touchend", handler, true);
}


  function initAll() {
    initCarouselClickSelect();
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
